import request from "@/config/utils/request";
import blobRequest from "@/config/utils/requestBlob";
import { loadingParams } from "@/basa/utils/public";

//申诉反馈提交
export function saveSupAppealFeedback(data) {
  return request({
    url: "/apis/jrw/feedback/saveSupAppealFeedback",
    method: "post",
    data
  });
}
//申诉反馈列表查询
export function getSupAppealFeedbackList(data) {
  return request({
    url: "/apis/jrw/feedback/getSupAppealFeedbackList",
    method: "post",
    data
  });
}
//申诉反馈列表附件下载
export function gcpExportFilesToZip(data) {
  return blobRequest({
    url: "/apis/jrw/exportzip/gcpExportFilesToZip",
    method: "post",
    responseType: "blob",
    data: { ...data, ...loadingParams }
  });
}
//查询供应商注册一公院审查状态
export function qrySupYgyReviewState(data) {
  return request({
    url: "/apis/jrw/feedback/qrySupYgyReviewState",
    method: "post",
    data
  });
}
//查询供应商审查详情
export function qrySupReviewDetail(data) {
  return request({
    url: "/apis/jrw/feedback/qrySupReviewDetail",
    method: "post",
    data
  });
}

//查询供应商评价与反馈详情
export function getBatchScoreResult(data) {
  return request({
    url: "/apis/jrw/feedback/getBatchScoreResult",
    method: "post",
    data
  });
}

export function download(data) {
  return blobRequest({
    url: "/apis/jrw/feedback/download",
    method: "post",
    responseType: "blob",
    data
  });
}
